module.exports = __webpack_public_path__ + "img/legacy_letter_final_cropped.067008f6.jpg";